import types from "duck/types"

const getMessage = (payload) => ({ type: types.users.GET_MESSAGE, payload })
export default {
  getMessage,
}
